
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accountCAVgsnGbXOMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accountIkrxi4Rv4yMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordXpXrqX6TiPMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homem1eDYhFtebMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/home.vue?macro=true";
import { default as indexQICpXX3mrVMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/index.vue?macro=true";
import { default as login5e2KSRQc9fMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationsSsMIcS8nUSMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordDjWqliLforMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filtersx90Hf5TJtQMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groupsBz9Lo9bCLfMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93mz3o3c49ibMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexl6KO4rJlycMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_93RHzC6O7nS3Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientsPKEy5g4P0HMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheetsPWJnSbUpWLMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as index3xWM2Z81OoMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as new6F5fiapdBsMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as export3XTHA2IhuwMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexfJDRNrUuo9Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newxutfDm0muyMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93PSTGtv9SDsMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importVJaE4HZUClMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexJ0CODvWEW4Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createyF9gCxNdAxMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93WFLGBFLM5vMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93uNvPHj8c1eMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexXfT2AxrZSOMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventoriesVkAHEdWGfbMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventoryKhkvAYByRTMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexCKpNKe3Rp3Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activityhuncoyaZlRMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndownF0iwgBVf67Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexQHuvVZhRfcMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reporting2XtG2ekBO2Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_932VVUDVYT9gMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexCeDwJkbUPvMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointmentsQBaKcSa1xIMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as indexfMedPABRMkMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93NyqKjMxlSSMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmenthCmkWzRR7GMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardPSgWxrRomiMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as index08irsBBpxhMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_93TVgXuuf6n7Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsMidLGKHZ6oMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indextvZ7nMZpIKMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapwRHdMD4UIZMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexcDlXhINEGjMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksjd9sbMMATOMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rolloutNPmBqUqaXXMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointment46QAf8hfjsMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as branding7td9ZAOyzaMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createOJVM0Wx5QSMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_93omrl2igD3XMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexgfdZiqMXlgMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistsekX2Fiu2oDMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linksxpnGjR20wSMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsMAMDWpZdrdMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as indexwz9rTOYfHTMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsmGChLfK0vNMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutskQL80USOgcMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptionYnynuAkUY5Meta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as usersj7jex5euAXMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as create0Dor9E8qfZMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93SXVKcsgw6nMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as indexEBbi2UKyfcMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowsfKEMipKjWxMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settingsNgBAU9pcfDMeta } from "/codebuild/output/src72011423/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountCAVgsnGbXOMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accountIkrxi4Rv4yMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordXpXrqX6TiPMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homem1eDYhFtebMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexQICpXX3mrVMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login5e2KSRQc9fMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsSsMIcS8nUSMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordDjWqliLforMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventoryKhkvAYByRTMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filtersx90Hf5TJtQMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groupsBz9Lo9bCLfMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientsPKEy5g4P0HMeta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93mz3o3c49ibMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexl6KO4rJlycMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_93RHzC6O7nS3Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheetsPWJnSbUpWLMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: export3XTHA2IhuwMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: index3xWM2Z81OoMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: new6F5fiapdBsMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importVJaE4HZUClMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexfJDRNrUuo9Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newxutfDm0muyMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93PSTGtv9SDsMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexJ0CODvWEW4Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventoriesVkAHEdWGfbMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createyF9gCxNdAxMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93WFLGBFLM5vMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93uNvPHj8c1eMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexXfT2AxrZSOMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexCKpNKe3Rp3Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reporting2XtG2ekBO2Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activityhuncoyaZlRMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndownF0iwgBVf67Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexQHuvVZhRfcMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rolloutNPmBqUqaXXMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointmentsQBaKcSa1xIMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_932VVUDVYT9gMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexCeDwJkbUPvMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmenthCmkWzRR7GMeta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: indexfMedPABRMkMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93NyqKjMxlSSMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardPSgWxrRomiMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsMidLGKHZ6oMeta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: index08irsBBpxhMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_93TVgXuuf6n7Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indextvZ7nMZpIKMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapwRHdMD4UIZMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksjd9sbMMATOMeta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexcDlXhINEGjMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointment46QAf8hfjsMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settingsNgBAU9pcfDMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: branding7td9ZAOyzaMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistsekX2Fiu2oDMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createOJVM0Wx5QSMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_93omrl2igD3XMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexgfdZiqMXlgMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linksxpnGjR20wSMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsMAMDWpZdrdMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexwz9rTOYfHTMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrationsmGChLfK0vNMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutskQL80USOgcMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptionYnynuAkUY5Meta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: usersj7jex5euAXMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowsfKEMipKjWxMeta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: create0Dor9E8qfZMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93SXVKcsgw6nMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: indexEBbi2UKyfcMeta || {},
    component: () => import("/codebuild/output/src72011423/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]